import { useLiveStreamsListHelpers } from '../../LiveStreamsLister/liveStreamsListHelpers';
import { computed, ref } from "vue";
import { useForm } from "vee-validate";
import * as yup from 'yup';
import { submitCreatePlayerSubscription } from "@/helpers/api/player-subscription/create";
import { getKeyByValue } from '@/helpers/utils';
import ApprovalStatesMapping from '@/data/mappings/ApprovalStates.map';
import { log } from "@/helpers/utils";
import { useLiveStream } from '@/views/LiveStreamEditorView/composables/liveStream';

// TODO (cleanup): review any potential reusable code merging between this and `@/views/PlayerSubscriptionEditorView/composables/saveSubscriptionFormHelpers.ts`

export function useCreateLiveStreamFormHelpers() {
  // TODO: think about creating custom form handler that may be more cleaner or readable / easier to use than Vee-Validate [DSP-N23Gxg1I]
  const { mutateList, listHelperBasicInfo } = useLiveStreamsListHelpers();

  const { prepareDataForSubmission, bindingOptionsInitialValues } = useLiveStream();

  const isLoading = ref(false);
  const isSuccess = ref(false);
  const isError = ref(false);
  const errorMessage = ref("");
  const newSubscriptionId = ref("");

  const validationSchema = yup.object({
    name: yup.string().label('Name').required(),
    sideFeatureBindingOptions: yup.object({
      streamType: yup.string().label('Stream Type').required(),
      streamUrl: yup.string().label('Stream Url').required(),
      startDate: yup.string().label('Start Date').required(),
      startTime: yup.string().label('Start Time').required(),
      endDate: yup.string().label('End Date').required(),
      endTime: yup.string().label('End Time').required(),
    }),
    filters: yup.object({
      organizations: yup.array().label('Organizations').min(1, 'At least one organization is required')
    })
  });

  const initialValues = {
    name: "",
    sideFeatureBindingOptions: {
      ...bindingOptionsInitialValues,
      isStartStream: true,
    },
    // Target Players Filters (Like in Player Subscription Editor)
    filters: {
      organizations: [],
      locations: [],
      orientations: [],
      playerTags: [],
    },
    bindings: [],
    isActive: true,
  };

  const { errors, handleSubmit, values, setValues, isSubmitting } = useForm({ validationSchema, initialValues });
  const submitForm = handleSubmit(handleValidFormSubmit, handleInvalidFormSubmit);

  async function handleValidFormSubmit() {
    try {
      errorMessage.value = "";
      isLoading.value = true;
      const dataToSubmit = await prepareDataForSubmission(values);
      console.log('dataToSubmit', dataToSubmit);
      const submissionResponse = await submitCreatePlayerSubscription(dataToSubmit);
      console.log('submissionResponse', submissionResponse);
      
      isLoading.value = false;
      if (submissionResponse.success === true) {
        // if is successful
        isSuccess.value = true;
        newSubscriptionId.value = submissionResponse.data.id;
        mutateList();
      } else {
        console.error('Error while creating live stream', submissionResponse.errors)
        throw new Error("Unable to create live stream!")
      }
    } catch (error) {
      isError.value = true;
      isLoading.value = false;
      errorMessage.value = `Something went wrong. (${error})`;
    }
  }

  async function handleInvalidFormSubmit() {
    let errorsAugmentedInSingleMessage = "";
    // TODO (cleaner code): think if there's a cleaner way to write this [DSP-N26Cti4A]
    if(Object.keys(errors.value).length){
      Object.keys(errors.value).forEach((key) => {
        errorsAugmentedInSingleMessage += errors.value[key]+". ";
      });
    }
    errorMessage.value = errorsAugmentedInSingleMessage;
  }

  return {
    values,
    submitForm,
    isError,
    isSuccess,
    isLoading,
    errorMessage,
    newSubscriptionId,
  };
}
